module.exports = __webpack_public_path__ + "img/dku.02668.dda81e09.png";